import {Box} from "@mui/material";
import {LandingHeader} from "./components/LandingHeader";
import {Hero} from "./components/Hero";
import {Metrics} from "./components/Metrics";
import {ProblemStatement} from "./components/ProblemStatement";
import {HowItWorks} from "./components/HowItWorks";
import {Capabilities} from "./components/Capabilities";
import {Integrations} from "./components/Integrations";
import {Specs} from "./components/Specs";
import {Partners} from "./components/Partners";
import {Faq} from "./components/Faq";
import {ContactDemo} from "./components/ContactDemo";
import {LandingFooter} from "./components/LandingFooter";
import {c} from "./landingTokens";


export const LandingPage = () => {

  return (
    <Box
      sx={{
        bgcolor: c.bg,
        color: c.ink,
        fontFamily: "'Helvetica Neue', Helvetica, -apple-system, system-ui, sans-serif",
        overflowX: "hidden",
      }}
    >
      <LandingHeader />
      <Hero />
      <Metrics />
      <ProblemStatement />
      <HowItWorks />
      <Capabilities />
      <Integrations />
      <Specs />
      <Partners />
      <Faq />
      <ContactDemo />
      <LandingFooter />
    </Box>
  )
}
